export default "__VITE_ASSET__98a5c319__"